/**
 * French for the video player's own controls.
 *
 * Vidstack draws its control bar, menus and tooltips itself ("Play",
 * "Settings", "Captions"…), so those words never pass through our catalogue.
 * It takes a translation table instead; this is it. Kept as a typed record so
 * a word Vidstack adds in an upgrade shows up as a missing key here.
 */
import type { DefaultLayoutTranslations } from "@vidstack/react/player/layouts/default";
import { useLocale } from "./index";

const FR: DefaultLayoutTranslations = {
  Announcements: "Annonces",
  Accessibility: "Accessibilité",
  AirPlay: "AirPlay",
  Audio: "Audio",
  Auto: "Auto",
  Boost: "Amplification",
  Captions: "Sous-titres",
  "Caption Styles": "Style des sous-titres",
  "Captions look like this": "Les sous-titres ressemblent à ceci",
  Chapters: "Chapitres",
  "Closed-Captions Off": "Sous-titres désactivés",
  "Closed-Captions On": "Sous-titres activés",
  Connected: "Connecté",
  Continue: "Continuer",
  Connecting: "Connexion…",
  Default: "Par défaut",
  Disabled: "Désactivé",
  Disconnected: "Déconnecté",
  "Display Background": "Arrière-plan de l’affichage",
  Download: "Télécharger",
  "Enter Fullscreen": "Plein écran",
  "Enter PiP": "Image dans l’image",
  "Exit Fullscreen": "Quitter le plein écran",
  "Exit PiP": "Quitter l’image dans l’image",
  Font: "Police",
  Family: "Famille",
  Fullscreen: "Plein écran",
  "Google Cast": "Google Cast",
  "Keyboard Animations": "Animations clavier",
  LIVE: "EN DIRECT",
  Loop: "Lecture en boucle",
  Mute: "Couper le son",
  Normal: "Normale",
  Off: "Désactivé",
  Pause: "Pause",
  Play: "Lecture",
  Playback: "Lecture",
  PiP: "Image dans l’image",
  Quality: "Qualité",
  Replay: "Revoir",
  Reset: "Réinitialiser",
  "Seek Backward": "Reculer",
  "Seek Forward": "Avancer",
  Seek: "Rechercher",
  Settings: "Paramètres",
  "Skip To Live": "Passer au direct",
  Speed: "Vitesse",
  Size: "Taille",
  Color: "Couleur",
  Opacity: "Opacité",
  Shadow: "Ombre",
  Text: "Texte",
  "Text Background": "Arrière-plan du texte",
  Track: "Piste",
  Unmute: "Rétablir le son",
  Volume: "Volume",
};

/** The table for the current language; null keeps Vidstack's English. */
export function usePlayerTranslations(): DefaultLayoutTranslations | null {
  return useLocale() === "fr" ? FR : null;
}
